<template>
    <text class="ui-icon" :style="{'font-size': fontSize, color: color}" @click="onClick(type)">
        {{ icons[type] }}
    </text>
</template>

<script>
    import icons from './icons.js'

    export default {
        props: {
            /**
             * 图标类型
             */
            type: {
                type: String,
                default: ''
            },
            /**
             * 图标颜色
             */
            color: {
                type: String,
                default: ''
            },
            /**
             * 图标大小
             */
            size: {
                type: [Number, String],
                default: 20
            }
            /**
             * 图标
             */
        },
        data() {
            return {
                icons: icons
            }
        },
        computed: {
            fontSize() {
                return `${this.size}px`
            }
        },
        methods: {
            onClick(e) {
                this.$emit('iconclick', e)
            }
        }
    }
</script>

<style scoped>
    @charset "UTF-8";
    @font-face {
        font-family: 'jiuiconfont';  /* Project id 3174369 */
        src: url('//at.alicdn.com/t/c/font_3174369_ssfbbrji6r.eot?t=1684657601139'); /* IE9 */
        src: url('//at.alicdn.com/t/c/font_3174369_ssfbbrji6r.eot?t=1684657601139#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('//at.alicdn.com/t/c/font_3174369_ssfbbrji6r.woff2?t=1684657601139') format('woff2'),
        url('//at.alicdn.com/t/c/font_3174369_ssfbbrji6r.woff?t=1684657601139') format('woff'),
        url('//at.alicdn.com/t/c/font_3174369_ssfbbrji6r.ttf?t=1684657601139') format('truetype'),
        url('//at.alicdn.com/t/c/font_3174369_ssfbbrji6r.svg?t=1684657601139#jiuiconfont') format('svg');
    }
    .ui-icon {
        font-family: 'jiuiconfont';
        line-height: 1;
        text-decoration: none;
        text-align: center;
    }
</style>
